import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from 'components/Loadable';
import Loader from 'components/Loader';
import AuthLoadingScreen from 'components/AuthLoadingScreen';
import { useAuth } from 'contexts/AuthContext';

// render - Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const DashboardLayout = Loadable(lazy(() => import('layout/Dashboard')));
const TransactionsPage = Loadable(lazy(() => import('pages/transactions')));
const PaymentLinksPage = Loadable(lazy(() => import('pages/payment-links')));
const UserManagementPage = Loadable(lazy(() => import('pages/user-management')));
const MerchantsPage = Loadable(lazy(() => import('pages/merchants')));
const MerchantBalancesPage = Loadable(lazy(() => import('pages/merchant-balances')));
const SettingsPage = Loadable(lazy(() => import('pages/settings')));

// Protected Route Component
function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <AuthLoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Admin Only Route Component
function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return <AuthLoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <ProtectedRoute><DashboardLayout /></ProtectedRoute>,
  children: [
    {
      path: '/',
      element: <Navigate to="/dashboard" replace />
    },
    {
      path: 'dashboard',
      children: [
        { index: true, element: <DashboardDefault /> },
        { path: 'default', element: <Navigate to="/dashboard" replace /> }
      ]
    },
    {
      path: 'transactions',
      element: <TransactionsPage />
    },
    {
      path: 'payment-links',
      element: <PaymentLinksPage />
    },
    {
      path: 'user-management',
      element: <AdminRoute><UserManagementPage /></AdminRoute>
    },
    {
      path: 'merchants',
      element: <AdminRoute><MerchantsPage /></AdminRoute>
    },
    {
      path: 'merchant-balances',
      element: <AdminRoute><MerchantBalancesPage /></AdminRoute>
    },
    {
      path: 'settings',
      element: <SettingsPage />
    }
  ]
};

export default MainRoutes;
